import EStyleSheet from "react-native-extended-stylesheet";

export const styles = EStyleSheet.create({
  checkbox: {
    width: "46vmin",
    margin: -10,
    fontSize: "$consent_icon_size",
  },
  text: {
    fontSize: "$consent_text_size",
    fontFamily: "$consent_text_style",
  },
});
